var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H131V131H0V0Z",
    fill: "white",
    fillOpacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4989 120.083C95.6444 120.083 120.082 95.6456 120.082 65.5001C120.082 35.3545 95.6444 10.9167 65.4989 10.9167C35.3533 10.9167 10.9155 35.3545 10.9155 65.5001C10.9155 95.6456 35.3533 120.083 65.4989 120.083Z",
    fill: "#399E79",
    stroke: "black",
    strokeWidth: 7.31632,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4995 43.6667V87.3334",
    stroke: "white",
    strokeWidth: 7.31632,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.666 65.5H87.3327",
    stroke: "white",
    strokeWidth: 7.31632,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUploadIcon);
export default __webpack_public_path__ + "static/media/addUploadIcon.0543f9f8d4ef8284696cb092e028af0b.svg";
export { ForwardRef as ReactComponent };